<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="Course-Main-Tab" class="data-list-container">
      <div slot="no-body" class="tabs-container  pb-6">
         <div class="tab-text">
           <!-- 1 -->
                <div class="vx-row">
                    <div class="vx-col lg:w-1/3 w-full">
                      <vs-input :label="$t('Code')" v-model="trackModel.Code"  class="mt-5 w-full" name="CourseCode"  />
                      <span class="text-danger text-sm" v-show="errors.has('CourseCode')">{{ errors.first('CourseCode') }}</span>
                    </div>
                      <div class="vx-col lg:w-1/3 w-full mt-5">
                          <label class="vs-input--label">{{$t('Provider')}}</label>
                                  <v-select
                                    label="Name"
                                    autocomplete
                                    v-model="trackModel.ProviderID"
                                    :options="Providers"
                                    :reduce="Provider => Provider.ID"
                                  />
                          </div>
                     <div class="vx-col lg:w-1/3 w-full ">
                      <vs-input :label="$t('Name')" v-model="trackModel.Name" class="mt-5 w-full" name="name" v-validate="'required'" />
                      <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    </div>
                </div>
                 <!-- 2 -->
                <div class="vx-row">
                   <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t("Language")}}</label>
                                  <v-select
                                    label="Name"
                                    autocomplete
                                    multiple
                                    v-model="trackModel.languages"
                                    :options="getLanguage"
                                    :reduce="language => language.ID"
                                  />
                          </div>
                      <!-- <vs-select   multiple autocomplete class="vx-col lg:w-1/3 w-full mt-5" label="language" v-model="trackModel.languages">
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in getLanguage" />
                    </vs-select> -->
                       <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t('AreaOfStudy')}}</label>
                                  <v-select
                                    label="Name"
                                    autocomplete
                                    multiple
                                    v-model="trackModel.areaOfStudies"
                                    :options="getCourseAreaOfStudyList"
                                    :reduce="areaOfStudy => areaOfStudy.ID"
                                  />
                          </div>

                     <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t('IndustrySector')}}</label>
                                  <v-select
                                    label="Name"
                                    autocomplete
                                    multiple
                                    v-model="trackModel.industrySectors"
                                    :options="getindustrySector"
                                    :reduce="Industry => Industry.ID"
                                  />
                          </div>

                </div>
                <!-- 3 -->
                <div class="vx-row">
                   <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t('Level')}}</label>
                                  <v-select
                                    label="Name"
                                     v-model="trackModel.TrackLevelID"
                                    :options="getCourseLevel"
                                    :reduce="Level => Level.ID"
                                  />
                          </div>

                        <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t('DiplomaCourses')}}</label>
                                  <v-select
                                    label="Name"
                                    multiple autocomplete
                                     v-model="trackModel.electiveCourses"
                                    :options="getCourses"
                                    :reduce="Course => Course.ID"
                                  />
                          </div>
                    <!-- <vs-select   multiple autocomplete class="vx-col lg:w-1/3 w-full mt-5" label="Elective Courses" v-model="trackModel.electiveCourses">
                      <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in getCourses" />
                    </vs-select> -->
                </div>
                 <div class="vx-col w-full" style="padding-top:20px">
                    <label class="vs-input--label">{{$t('About')}}</label>
                       <vs-textarea  v-model="trackModel.About"  class="w-full" name="Documentation"  />
                    </div>

                <div class="vx-row">
                    <div class="vx-col  w-full" style="padding-top:20px">
                        <label class="vs-input--label">{{$t('Objectives')}}</label>
                        <quill-editor v-model="trackModel.Content"  />
                    </div>
                </div>
                <!-- 8 -->
                <div class="vx-row mt-5">
                  <div class="vx-col lg:w-1/2 w-full">
                    <label class="vs-input--label">{{$t('Prerequisite')}}</label>
                      <quill-editor   v-model="trackModel.Prerequisite"  class="mt-5 w-full" name="Prerequisite" />
                  </div>
                   <div class="vx-col lg:w-1/3 w-full">
                          <label class="vs-input--label">{{$t('PopulationList')}}</label>
                                  <v-select
                                    label="Name"
                                    multiple autocomplete
                                     v-model="trackModel.populationList"
                                    :options="getPopulationList"
                                    :reduce="Population => Population.ID"
                                  />
                          </div>

                  </div>
                  <!-- 9 -->
                <div class="vx-row">
               <div class="vx-col lg:w-1/2 w-full">
                  <label class="vs-input--label">{{$t('References')}}</label>
                    <quill-editor  v-model="trackModel.References"  class="mt-5 w-full" name="References" />
                </div>

                </div>
            </div>
      </div>
  </div>
</template>
<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import vSelect from 'vue-select'
import moduleCourse from "@/store/course/moduleCourse.js";

export default {
  components: {
     vSelect,
     quillEditor
  },
   props: {
    trackModel: {
      type: Object,
     required: true,
    }
  },

  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    Providers () {
      return this.$store.state.ProviderList.providers ;
    },


    getCourseLevel()
    {
        return this.$store.state.courseLevelList.courseLevels;
    },
     getLanguage()
    {
        return this.$store.state.languageList.languages;
    },

      getindustrySector()
    {
        return this.$store.state.industrySectorList.industrySectors;
    },

    getCourseAreaOfStudyList()
    {
      return this.$store.state.courseAreaOfStudyList.courseAreaOfStudies;
    },

    getPopulationList()
    {
       return this.$store.state.populationListList.populationLists;
    },

    getCourses()
    {
       return this.$store.state.courseList.courses;
    },
  },

  methods: {

  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
     this.$store.dispatch("courseList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
  input[type="color" i]{
    height: 35px!important;
  }
  #colorPicer .vs-input--input.normal
  {
  padding: 0.2rem
  }
</style>
